export default "__VITE_ASSET__fbc53d55__"